import React from "react";
import { LegalLayout } from "../../components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. Overview",
    body: [
      "This Privacy Notice explains how ATLAS (\u201cAtlas\u201d) processes personal data. It is drafted with reference to the EU General Data Protection Regulation (GDPR) and Netherlands data protection law, and is a draft pending confirmation by qualified Netherlands/EU counsel.",
      "Atlas is a prototype. Data described here reflects the intended design.",
    ],
  },
  {
    heading: "2. Data controller",
    body: [
      "For the purposes of the GDPR, the entity operating Atlas would act as the data controller for account data. Full controller identity and contact details will be confirmed before production launch.",
    ],
  },
  {
    heading: "3. What we collect",
    body: [
      "Account data: your name, email address, hashed password, and your Terms acceptance record (the Terms version, and the date and time you accepted).",
      "Usage data: searches, comparisons and reports you submit, used to operate and improve the service.",
      "We do not collect payment card details because Atlas does not process vehicle payments.",
    ],
  },
  {
    heading: "4. Legal bases for processing (GDPR Art. 6)",
    body: [
      "We rely on: performance of a contract (providing your account and the service); your consent (where applicable); and our legitimate interests (securing the service, preventing fraud and abuse), balanced against your rights.",
    ],
  },
  {
    heading: "5. How we use data",
    body: [
      "To create and secure your account, record your acceptance of the Terms, operate search/compare/reporting features, respond to issue reports, and prevent fraud or misuse.",
    ],
  },
  {
    heading: "6. Retention",
    body: [
      "Account and Terms-acceptance records are retained while your account is active and for a limited period afterwards as needed for legal and security purposes. Final retention periods will be confirmed by counsel.",
    ],
  },
  {
    heading: "7. Your rights (GDPR)",
    body: [
      "Subject to applicable law, you have the right to access, rectify, erase, restrict, port and object to processing of your personal data, and to lodge a complaint with a supervisory authority (in the Netherlands, the Autoriteit Persoonsgegevens).",
      "You can exercise data rights or raise a concern through the Report an Issue tool; a dedicated privacy contact will be provided before production launch.",
    ],
  },
  {
    heading: "8. Sharing and third parties",
    body: [
      "Atlas displays information from third-party sources but does not sell your personal data. Any processors used to operate the service will be bound by appropriate data-processing terms.",
    ],
  },
  {
    heading: "9. Security",
    body: [
      "Passwords are stored only as salted hashes. We apply reasonable technical and organisational measures appropriate to a prototype; production-grade controls will be finalised before launch.",
    ],
  },
  {
    heading: "10. Changes",
    body: [
      "We may update this Notice. Material changes will be reflected in the version identifier shared across Atlas legal documents.",
    ],
  },
];

export default function LegalPrivacy() {
  return (
    <LegalLayout
      testid="legal-privacy"
      currentPath="/legal/privacy"
      title="Privacy Notice"
      intro="How Atlas processes personal data, drafted with reference to GDPR and Netherlands data protection law. Draft, pending legal review."
      sections={SECTIONS}
    />
  );
}
